import { React, useState, useEffect, useContext } from 'react'
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant"
import { AuthContext } from '../../../component/context/AuthContext';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datetime';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { FiDownload } from 'react-icons/fi';
import LeaveAndCompoffDetails from './LeaveAndCompoffDetails';

function List() {
	const [authUserData] = useContext(AuthContext);
	const [fullLoading, setFullLoading] = useState(false);
	const [validate, setValidate] = useState({});
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [filterUsers, setfilterUsers] = useState([]);

	const [srchMonth, setSrchMonth] = useState('');
	const [srchYear, setSrchYear] = useState(moment().format('YYYY'));
	const [srchEmpName, setSrchEmpName] = useState("");
	const [srchEmpEmail, setSrchEmpEmail] = useState("");
	const [srchBalanceFlag, setSrchBalanceFlag] = useState("");
	const [dptListing, setDptListing] = useState([]);
	const [srchEmpDepartment, setSrchEmpDepartment] = useState("");
	const [srchdesignation, setsrchDesignation] = useState("");
	const [desigListing, setDesigListing] = useState([]);

	// Popup state
	const [showDetailModal, setShowDetailModal] = useState(false);
	const [detailType, setDetailType] = useState(""); // "leaves" or "compoff"
	const [detailEmp, setDetailEmp] = useState(null);
	const [detailData, setDetailData] = useState([]);
	const [detailLoading, setDetailLoading] = useState(false);

	let isToken = '';
	let department_id = '';
	let is_admin = 0;
	let default_dpt_id = '';
	if (authUserData) {
		if (authUserData[0]) {
			isToken = authUserData[0].token ? authUserData[0].token : "";
			is_admin = authUserData[0].is_admin ? authUserData[0].is_admin : 0;
			department_id = authUserData[0].department_id ? authUserData[0].department_id : "";
		}
	}
	if (is_admin == 1 || department_id == 5 || department_id == 8) {
		default_dpt_id = "";
	} else {
		default_dpt_id = department_id;
	}

	const [totalRecords, settotalRecords] = useState(0);
	const [totalRows, setTotalRows] = useState(0);
	const [perPage, setPerPage] = useState(20);
	const [maxPageLimit, setMaxPageLimit] = useState(20);
	const [minPageLimit, setMinPageLimit] = useState(0);
	const [activePage, setActivePage] = useState(1);
	const [dataSort, setDataSort] = useState({ order: 'desc', order_by: 'id' });
	const [searchParam, setSearchParam] = useState({
		srchEmpName: "", srchEmpEmail: "", srchEmpDepartment: default_dpt_id, srchdesignation: "",
	});

	useEffect(() => {
		if (isToken) {
			fetchUserData();
			fetchDeptList();
		}
	}, [searchParam, dataSort, activePage, perPage, isToken]);

	async function fetchUserData() {
		setLoading(true);
		try {
			const response = await axios.post(CONST.EMP_ALL_COMPOFF, {
				limit: perPage,
				page_number: activePage,
				search_input: searchParam,
				sort: dataSort,
				year: srchYear,
				month: srchMonth,
			}, { headers: { 'Authorization': `Bearer ${isToken}` } });

			if (response.data.status === 'success') {
				setTotalRows(response.data.count);
				settotalRecords(response.data.count);
				// Compute balance from designation.leaves_allocated
				const users = (response.data.data || []).map(user => {
					const leavesAllocated = user.designation?.leaves_allocated || 0;
					const consumed = user.total_consumed_leaves_count || 0;
					const balance = leavesAllocated > 0 ? leavesAllocated - consumed : 0;
					return { ...user, totalLeaveCount: leavesAllocated, consumedLeaveCount: consumed, balanceLeaveCount: balance };
				});
				setData(users);
				setfilterUsers(users.map(u => ({
					...u,
					first_name: `${u.first_name || ''} ${u.last_name || ''}`,
					department: u.department ? u.department.name : '',
					designation: u.designation ? u.designation.name : '',
				})));
			} else {
				setTotalRows(0); setData([]); settotalRecords(0);
			}
		} catch (error) {
			setData([]); setTotalRows(0); settotalRecords(0);
		}
		setLoading(false);
	}

	async function fetchDeptList() {
		try {
			const res = await axios.get(CONST.GET_DEPARTMENT, { headers: { 'Authorization': `Bearer ${isToken}` } });
			if (res.data.status === 'success') setDptListing(res.data.data || []);
		} catch (error) { }
	}

	const fetchDesigtList = async (desig_id) => {
		setSrchEmpDepartment(desig_id);
		if (desig_id) {
			try {
				const res = await axios.get(CONST.GET_DESIG_BY_ID + '/' + desig_id, { headers: { 'Authorization': `Bearer ${isToken}` } });
				if (res.data.status === 'success') setDesigListing(res.data.data || []);
				else setDesigListing([]);
			} catch (error) { setDesigListing([]); }
		} else { setDesigListing([]); }
	};

	// Open leaves/compoff popup
	const openDetailPopup = async (row, type) => {
		setDetailEmp(row);
		setDetailType(type);
		setShowDetailModal(true);
		setDetailLoading(true);
		setDetailData([]);

		const year = srchYear || moment().format('YYYY');
		const month = srchMonth || "";

		try {
			if (type === "leaves") {
				const res = await axios.post(CONST.LEAVES_BY_EMP_ID, {
					id: row.id, limit: 1000, page_number: 1, year, month,
					search_input: { srchStatus: "", srchLeaveType: "", srchDateOfLeaves: "", srchDateOfLeavesApply: "" },
					sort: { order: "desc", order_by: "id" }
				}, { headers: { Authorization: `Bearer ${isToken}` } });
				setDetailData(res.data.data || []);
			} else {
				const res = await axios.post(CONST.COMPOFF_BY_EMP_ID, {
					user_id: row.id, limit: 1000, page_number: 1, year, month,
					srchCompOffDate: "", srchAppliedDate: "", status: "",
					sort: { order: "desc", order_by: "id" }
				}, { headers: { Authorization: `Bearer ${isToken}` } });
				setDetailData(res.data.data || []);
			}
		} catch (error) {
			console.log("Error fetching detail:", error);
		}
		setDetailLoading(false);
	};

	// Download Excel with 2 sheets (Leaves + Comp-Off)
	const downloadEmployeeExcel = async (row) => {
		try {
			setFullLoading(true);
			const response = await axios.post(
				CONST.DOWNLOAD_EMPLOYEE_REPORT,
				{ emp_id: row.id, year: srchYear || moment().format('YYYY'), month: srchMonth || "" },
				{ headers: { 'Authorization': `Bearer ${isToken}` }, responseType: 'blob' }
			);
			const fileName = `${row.first_name}_${row.last_name}_${srchYear || moment().format('YYYY')}_report.xlsx`;
			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = fileName;
			link.click();
			setFullLoading(false);
			toast.success("Report downloaded successfully");
		} catch (error) {
			setFullLoading(false);
			toast.error("Error downloading report");
		}
	};

	// Status badge
	const StatusBadge = ({ status }) => {
		const map = {
			0: { label: "Pending", bg: "#fffbeb", color: "#d97706" },
			1: { label: "Approved", bg: "#ecfdf5", color: "#059669" },
			2: { label: "Rejected", bg: "#fef2f2", color: "#dc2626" },
			3: { label: "Cancelled", bg: "#f1f5f9", color: "#94a3b8" },
		};
		const s = map[status] || map[0];
		return <span style={{ background: s.bg, color: s.color, padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{s.label}</span>;
	};

	// Balance helpers
	const getBalanceFlag = (total, balance) => {
		if (total <= 0) return "green";
		const currentMonth = new Date().getMonth() + 1;
		const expectedBalance = (total / 12) * (12 - currentMonth);
		if (balance <= expectedBalance * 0.5) return "red";
		if (balance <= expectedBalance * 0.85) return "warning";
		return "green";
	};
	const getBalanceBadgeClass = (flag) => {
		if (flag === "red") return "bg-danger";
		if (flag === "warning") return "bg-warning text-dark";
		return "bg-success";
	};

	const filteredData = srchBalanceFlag && data
		? data.filter((row) => getBalanceFlag(row.totalLeaveCount || 0, row.balanceLeaveCount || 0) === srchBalanceFlag)
		: data;

	// Table columns
	const columns = [
		{
			name: "Employee",
			cell: (row) => (
				<div className="d-flex py-1 align-items-center">
					<span className="avatar rounded-circle">
						{row.profile_photo_path
							? <img src={CONST.HOST + row.profile_photo_path} alt="" width={36} className="rounded-circle" />
							: <span className="avatar-initials">{(row.first_name || '').substring(0, 1)}{(row.last_name || '').substring(0, 1)}</span>
						}
					</span>
					<div className="flex-fill pl-2">
						<div className="font-weight-medium">{row.first_name} {row.last_name}</div>
						<div className="text-muted"><small>{row.email}</small></div>
						<div className="text-muted"><small>{row.department?.name || '-'}</small></div>
					</div>
				</div>
			),
			sortField: "first_name", sortable: true, width: "30%", wrap: true,
		},
		{
			name: "Leaves Taken",
			cell: (row) => (
				<Link to="#" onClick={() => openDetailPopup(row, "leaves")} style={{ fontWeight: 600, color: '#1167e8', textDecoration: 'underline', cursor: 'pointer' }}>
					{row.total_consumed_leaves_count || 0}
				</Link>
			),
			sortField: "total_consumed_leaves_count", sortable: true, width: "12%",
		},
		{
			name: "Total Comp-Off",
			cell: (row) => (
				<Link to="#" onClick={() => openDetailPopup(row, "compoff")} style={{ fontWeight: 600, color: '#059669', textDecoration: 'underline', cursor: 'pointer' }}>
					{row.total_ecompoffusers_count || 0}
				</Link>
			),
			sortField: "total_ecompoffusers_count", sortable: true, width: "12%",
		},
		{
			name: "Leave Balance",
			cell: (row) => {
				const total = row.totalLeaveCount || 0;
				const consumed = row.consumedLeaveCount || 0;
				const balance = row.balanceLeaveCount || 0;
				const flag = getBalanceFlag(total, balance);
				return (
					<div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
						<span style={{ background: '#f0f5ff', color: '#1167e8', padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{total} Total</span>
						<span style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{consumed} Used</span>
						<span className={`badge rounded-pill ${getBalanceBadgeClass(flag)}`}>{balance} Bal</span>
					</div>
				);
			},
			width: "28%", wrap: true,
		},
		{
			name: "Download",
			cell: (row) => (
				<button className='btn btn-link btn-sm p-0 m-0 border-0' title="Download Excel" onClick={() => downloadEmployeeExcel(row)}>
					<FiDownload size={18} className="text-primary" />
				</button>
			),
			width: "8%",
		},
	];

	// Search
	const handleSearch = () => {
		setSearchParam({ srchEmpName, srchEmpEmail, srchEmpDepartment, srchdesignation });
		setActivePage(1);
	};
	const handleReSetSearch = () => {
		setSrchEmpName(""); setSrchEmpEmail(""); setSrchEmpDepartment(""); setSrchBalanceFlag("");
		setsrchDesignation(""); setSrchMonth(""); setSrchYear(moment().format("YYYY"));
		setSearchParam({ srchEmpName: "", srchEmpEmail: "", srchEmpDepartment: "", srchdesignation: "" });
		setActivePage(1);
	};
	const handleSort = (column, sortDirection) => {
		setActivePage(1);
		setDataSort({ order: sortDirection, order_by: column.sortField });
	};
	const handlePageChange = (page) => setActivePage(parseInt(page));
	const handlePageLimit = (val) => { setPerPage(parseInt(val)); setActivePage(1); };

	// Pagination
	const BootyPagination = ({ rowCount, onChangePage, currentPage }) => {
		const pages = Math.ceil(rowCount / perPage);
		const pageItems = [];
		for (let i = 1; i <= pages; i++) pageItems.push(i);
		const paginationText = `Page: ${currentPage}, Showing ${(currentPage - 1) * perPage + 1} to ${Math.min(perPage * currentPage, rowCount)} of ${rowCount}`;
		return (
			<div className='row card-footer'>
				<div className='col-md-4 align-self-center'>{paginationText}</div>
				<div className='col-md-8 text-align-right'>
					<ul className="pagination text-align-right float-right">
						<li className="page-item"><button className="page-link" onClick={() => onChangePage(currentPage - 1)} disabled={currentPage === 1}>«</button></li>
						{pageItems.map((page, i) => page <= maxPageLimit && page > minPageLimit ? (
							<li key={i} className={`page-item ${currentPage === page ? "active" : ""}`}>
								<button className={`page-link ${currentPage === page ? "active" : ""}`} onClick={() => onChangePage(page)}>{page}</button>
							</li>
						) : null)}
						<li className="page-item"><button className="page-link" onClick={() => onChangePage(currentPage + 1)} disabled={currentPage === pages}>»</button></li>
					</ul>
				</div>
			</div>
		);
	};

	const CustomLoader = () => (<div style={{ padding: "24px" }}><DivLoader color="primary" /></div>);

	return (
		<>
			<Loading loading={fullLoading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
			<div className="page-header d-print-none">
				<div className="container-xl">
					<div className="row g-2 align-items-center">
						<div className="col">
							<div className="page-pretitle">Report</div>
							<h2 className="page-title">Employee Leaves and Comp-Off</h2>
						</div>
					</div>
				</div>
			</div>
			<div className="page-body">
				<div className="container-xl">
					<div className="row row-cards">
						<div className="col-12">
							<div className="card">
								<div className="card-header">
									<h3 className="card-title">Listing</h3>
								</div>
								<div className="card-body border-bottom py-3">
									<div className="row">
										<div className="col-md-2">
											<div className="form-group mb-3">
												<label className="form-label">Name</label>
												<input type="text" className="form-control" placeholder="Enter name" onChange={(e) => setSrchEmpName(e.target.value)} value={srchEmpName} />
											</div>
										</div>
										<div className="col-md-2">
											<div className="form-group mb-3">
												<label className="form-label">Email</label>
												<input type="text" className="form-control" placeholder="Enter email" onChange={(e) => setSrchEmpEmail(e.target.value)} value={srchEmpEmail} />
											</div>
										</div>
										{(department_id == 5 || department_id == 8 || is_admin == 1) && (
											<>
												<div className="col-md-2">
													<div className="mb-3">
														<label className="form-label">Department</label>
														<select className="form-select form-control" onChange={(e) => fetchDesigtList(e.target.value)} value={srchEmpDepartment}>
															<option value="">All</option>
															{dptListing.map((d, i) => <option key={i} value={d.id}>{d.name}</option>)}
														</select>
													</div>
												</div>
												<div className="col-md-2">
													<div className="mb-3">
														<label className="form-label">Designation</label>
														<select className="form-select form-control" onChange={(e) => setsrchDesignation(e.target.value)} value={srchdesignation}>
															<option value="">All</option>
															{desigListing.map((d, i) => <option key={i} value={d.id}>{d.name}</option>)}
														</select>
													</div>
												</div>
											</>
										)}
										<div className="col-md-1">
											<div className="mb-3">
												<label className="form-label">Month</label>
												<DatePicker value={srchMonth} dateFormat="MM" timeFormat="" onChange={(val) => setSrchMonth(val ? moment(val).format('MM') : '')} />
											</div>
										</div>
										<div className="col-md-1">
											<div className="mb-3">
												<label className="form-label">Year</label>
												<DatePicker value={srchYear} dateFormat="YYYY" timeFormat="" onChange={(val) => setSrchYear(val ? moment(val).format('YYYY') : '')} />
											</div>
										</div>
										<div className="col-md-2">
											<div className="mb-3">
												<label className="form-label">Balance</label>
												<select className="form-select form-control" value={srchBalanceFlag} onChange={(e) => setSrchBalanceFlag(e.target.value)}>
													<option value="">All</option>
													<option value="red">Critical</option>
													<option value="warning">Warning</option>
													<option value="green">On Track</option>
												</select>
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group mb-3">
												<label className="form-label">&nbsp;</label>
												<div>
													<button type="button" className="btn btn-blue d-none d-sm-inline-block mr-2" onClick={handleSearch}>
														<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
															<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="10" cy="10" r="7"></circle><line x1="21" y1="21" x2="15" y2="15"></line>
														</svg>Search
													</button>&nbsp;
													<button type="button" className="btn btn-outline-primary mr-2" onClick={handleReSetSearch}>
														<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
															<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
														</svg>Clear
													</button>
												</div>
											</div>
										</div>
									</div>
									<div className='row'>
										<div className="col-md-6">
											<nav className="limit-pagination pt-3">
												<span>Rows per page:</span>
												<select className="sc-cwSeag jaZsat" value={perPage} onChange={(e) => handlePageLimit(e.target.value)}>
													<option value="10">10</option><option value="20">20</option><option value="30">30</option><option value="50">50</option><option value="100">100</option>
												</select>
											</nav>
										</div>
									</div>
								</div>
								<div className="table-responsive">
									<DataTable
										columns={columns}
										data={filteredData || []}
										progressPending={loading}
										progressComponent={<CustomLoader />}
										pagination
										paginationServer
										paginationTotalRows={totalRows}
										onChangePage={handlePageChange}
										paginationPerPage={perPage}
										paginationComponent={BootyPagination}
										sortServer
										onSort={handleSort}
										striped
										highlightOnHover
									/>
								</div>
								<div className="card-footer d-flex align-items-center">
									<p className="m-0 text-muted">Showing <span>{totalRecords}</span> entries</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Detail Popup - Leaves or Comp-Off listing */}
			<Modal size="lg" show={showDetailModal} onHide={() => setShowDetailModal(false)}>
				<Modal.Header closeButton style={{ borderBottom: 'none' }}>
					<Modal.Title>
						{detailEmp ? `${detailEmp.first_name} ${detailEmp.last_name}` : ''} - {detailType === "leaves" ? "Leaves" : "Comp-Off"}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{detailLoading ? (
						<div className="text-center py-4"><DivLoader color="primary" /></div>
					) : detailData.length === 0 ? (
						<p className="text-muted text-center py-3">No records found.</p>
					) : detailType === "leaves" ? (
						<table className="table table-sm table-bordered" style={{ fontSize: '0.82rem' }}>
							<thead style={{ background: '#f0f5ff' }}>
								<tr><th>#</th><th>Type</th><th>Category</th><th>Date</th><th>Subject</th><th>Status</th><th>Approver</th></tr>
							</thead>
							<tbody>
								{detailData.map((l, i) => (
									<tr key={i}>
										<td>{i + 1}</td>
										<td>{l.leave_type == 1 ? 'Full Day' : l.leave_type == 2 ? 'Short Leave' : 'Half Day'}</td>
										<td>{l.e_leave_type?.name || '-'}</td>
										<td>
											{moment(l.leave_from_date).format('DD-MM-YYYY')}
											{l.leave_type == '1' && l.leave_to_date ? ' to ' + moment(l.leave_to_date).format('DD-MM-YYYY') : ''}
										</td>
										<td>{l.subject || '-'}</td>
										<td><StatusBadge status={l.status} /></td>
										<td>{l.approvedByUser ? `${l.approvedByUser.first_name} ${l.approvedByUser.last_name}` : '-'}</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<table className="table table-sm table-bordered" style={{ fontSize: '0.82rem' }}>
							<thead style={{ background: '#f0fdf4' }}>
								<tr><th>#</th><th>Type</th><th>Date</th><th>Subject</th><th>Status</th></tr>
							</thead>
							<tbody>
								{detailData.map((c, i) => (
									<tr key={i}>
										<td>{i + 1}</td>
										<td>{c.leave_type == '1' ? 'Full Day' : 'Half Day'}</td>
										<td>{c.compoff_date ? moment(c.compoff_date).format('DD-MM-YYYY') : '-'}</td>
										<td>{c.UserstoCompoff?.subject || c.e_compoff?.subject || '-'}</td>
										<td><StatusBadge status={c.UserstoCompoff?.status ?? c.e_compoff?.status ?? 0} /></td>
									</tr>
								))}
							</tbody>
						</table>
					)}
				</Modal.Body>
			</Modal>
		</>
	)
}

export default List
